// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"fc1a03a2","408":"77d65f86","453":"cf3a2ade","754":"0085fdef","757":"8b673a49","894":"803f69d8","951":"c4ddc4bc","986":"1e2d591a","987":"45256085"}[chunkId] + ".css";
};